import { isFunction } from 'rxjs/util/isFunction';
import { isPlatformServer } from '@angular/common';
import { Component, Input, OnInit, ElementRef, AfterViewChecked, AfterViewInit, ChangeDetectorRef, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';

declare var Swiper: any;

@Component({
    selector: 'swiper',
    template: `<div class="swiper-container">
                    <ng-content></ng-content>
                </div>`,
    styles: [':host {display: block;}', ':host > div {width: 100%;height: 100%;}']
})
export class SwiperComponent implements AfterViewChecked, AfterViewInit, OnDestroy {
    // add all the options as optional settings and use them to create an options object
    @Input() config: any;
    @Input('initialize') set initialize(value: boolean) {
        this.shouldInitialize = this.initialized ? false : value;
    };

    Swiper: any;
    private isServer = false;
    private swiperWrapper: any;
    private slideCount = 0;
    private initialized = false;
    private shouldInitialize = true;

    constructor(private elementRef: ElementRef, private changeDetectorRef: ChangeDetectorRef, @Inject(PLATFORM_ID) platformId: string) {
        this.isServer = isPlatformServer(platformId); 
     }

    ngAfterViewInit() {
        if (this.shouldInitialize) {
            this.setup();
        }
    }

    setup() {
        if (!this.isServer && !this.Swiper) {
            // if rendered on server querySelector is undefined
            if (this.elementRef.nativeElement.querySelector) {
                this.swiperWrapper = this.elementRef.nativeElement.querySelector('.swiper-wrapper');
                this.slideCount = this.swiperWrapper.childElementCount;
                this.Swiper = new Swiper(this.elementRef.nativeElement.querySelector('swiper > div'), this.config);
                this.changeDetectorRef.detectChanges();
            }

            this.shouldInitialize = false;
        }
    }

    ngAfterViewChecked() {
        if (this.shouldInitialize) {
            this.setup();
        }

        if (!this.isServer && this.swiperWrapper && this.slideCount !== this.swiperWrapper.childElementCount) {
            this.slideCount = this.swiperWrapper.childElementCount;
            this.Swiper.update();
        }
    }

    private isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    private removeSwiperListenedFunctions(o: object){
        Object.keys(o).forEach(function(key) {
            let val = o[key];
            if(isFunction(val) && key.startsWith("on")){
                o[key] = new function() {};
            }
        });
    }

    private removeButtons(o: any){
        if (o.nextButton){
            o.nextButton = null;
        }
        if (o.prevButton){
            o.prevButton = null;
        }
        if (o.scrollbar){
            o.scrollbar = null
        }
    }

    ngOnDestroy(){
        if (!this.isServer && this.Swiper){
            

            //this.Swiper.originalParams = null;
            this.Swiper.destroy(true);
            this.removeSwiperListenedFunctions(this.Swiper.params);
            this.removeSwiperListenedFunctions(this.Swiper.originalParams);
            this.removeButtons(this.Swiper.params);
            this.removeButtons(this.Swiper.originalParams);
            this.removeButtons(this.Swiper);
//             if (this.Swiper.params.onInit){
//                 this.Swiper.params.onInit = new function() {};
//             }
//             if (this.Swiper.params.onSlideChangeStart){
//                 this.Swiper.params.onSlideChangeStart = new function() {};
//             }
//             if (this.Swiper.params.onSlideChangeEnd){
//                 this.Swiper.params.onSlideChangeEnd = new function() {};
//             }
//             if (this.Swiper.params.onLazyImageReady){
//                 this.Swiper.params.onLazyImageReady = new function() {};
//             }
//             if (this.Swiper.originalParams.onInit){
//                 this.Swiper.originalParams.onInit = new function() {};
//             }
//             if (this.Swiper.originalParams.onSlideChangeStart){
//                 this.Swiper.originalParams.onSlideChangeStart = new function() {};
//             }
//             if (this.Swiper.originalParams.onSlideChangeEnd){
//                 this.Swiper.originalParams.onSlideChangeEnd = new function() {};
//             }
//             if (this.Swiper.originalParams.onLazyImageReady){
//                 this.Swiper.originalParams.onLazyImageReady = new function() {};
//             }
            this.Swiper = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/swiper/swiper.component.ts